<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .icons {
        display: inline-block;
        width: 20px;
        height: 20px;
    }

    .toast-box {
        position: fixed;
        width: 80%;
        top: 30%;
        left: 10%;
        padding: 10px;
        z-index: 103;
        background: #fff;
    }

    .toast-bg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: 102;
    }

    .share-title {
        font-size: 18px;
        margin-bottom: 10px;
        padding-top: 10px;
    }

    .share-title a {
        margin: 0 10px;
    }

    .share-cancle {
        margin: 0 10px;
        border-top: 1px solid #dfdfdf;
        padding: 10px 0 0;
        font-size: 14px;
    }

    .img-share {
        width: 70%;
        position: absolute;
        right: 0;
        top: 0;
    }
</style>
<template>
    <section>
        <div v-if="type!=1" @click="toShare" class="content-shareimg"><img :src="shareimage" alt="" style="width: 100%">
        </div>
        <section class="toast-bg" v-if="status||statuses" @click.self="toCancel">
            <img v-if="statuses" class="img-share" src="../../assets/img/icon/shares.png" alt="">
        </section>
        <div class="toast-box border-radius-10" v-if="status">
            <p class="share-title text-center">分享</p>
            <p class="share-title text-center">
                <a class="icons qzone"
                   :href="'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url='+upVal(link)+'&title='+upVal(title)+'&pics='+upVal(desc)+'&summary='+upVal(title)+'&site='+upVal(title)+'&pics='+img+'&site='+upVal(title)+''"></a>
                <a class="icons qq"
                   :href="'http://connect.qq.com/widget/shareqq/index.html?url='+upVal(link)+'&title='+upVal(title)+'&source=亚朵&desc='+upVal(desc)+'&pics='+upVal(img)"></a>
                <a class="icons weibo"
                   :href="'http://service.weibo.com/share/share.php?url='+upVal(link)+'&title='+upVal(title)+'&pic='+upVal(img)+'&appkey='"></a>
            </p>
            <p class="share-cancle text-center" @click.self="toCancel">取消</p>
        </div>
    </section>
</template>

<script>
    export default {
        name: '',
        data() {
            return {
                status: false,
                statuses: false,
            }
        },
        props: ['callback', 'title', 'desc', 'imgUrl', 'link', 'type', 'shareimage'],
        methods: {
            upVal(val) {
                return encodeURI(val);
            },
            toCancel: function () {
//              this.status = false
                this.statuses = false
            },
            getWxToken: function (apiList, fun) {
                let _this = this
                var puurl = encodeURIComponent(location.href.split('#')[0]);
                //var url = "http://www.yaduo.com:9300/api/meb/GetCommonConfigByWechat?pageUrl=" + puurl;
//                var url = "http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=d92e36&isCorp=true&pageUrl=" + puurl;
                var url = "http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=ebf4d1&isCorp=false&pageUrl=" + puurl;//isCorp是否是企业号 线上公众号

//                var url = "http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=eff45e&isCorp=false&pageUrl=" + puurl;//isCorp是否是企业号  测试公众号
//                let url = "http://www.yaduo.com:9300/api/meb/ActMebDayByGetWechatConfig?pageUrl=" + encodeURIComponent(location.href.split('#')[0]);
                $.ajax({
                    url: url,
                    dataType: "json",
                    cache: true,
                    type: 'GET',
                    success: function (data) {
                        var cofigData = data.Data;
                        var config = {
                            debug: false, // 开启调试模式
                            appId: cofigData.AppId, // 必填，企业号的唯一标识，此处填写企业号corpid
                            timestamp: cofigData.TimeStamp, //必填，生成签名的时间戳
                            nonceStr: cofigData.NonceStr, // 必填，生成签名的随机串
                            signature: cofigData.Signature, // 必填，签名，见附录1
                            jsApiList: apiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        } //startRecord开始录音接口，startRecord识别音频并返回识别结果接口，stopRecord停止录音接口，playVoice播放语音接口
                        $(document).ready(function () {
                            wx.config(config);
                            wx.error(function (res) {
                            });
                            if (fun)
                                fun();
                            _this.$parent.$emit(_this.callback)
                        });
                    }
                });
            },
            weixinSdkConfig: function () {
                let _this = this
                let param = {
                    title: _this.title,
                    desc: _this.desc,
                    link: _this.link ? _this.link : window.location.href,
                    imgUrl: _this.imgUrl ? _this.imgUrl : 'http://on3q6c8d9.bkt.clouddn.com/WeChat/activity/share/shareImage1.jpg',
                    trigger: function (res) {
                        // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                    },
                    success: function (res) {
                    },
                    cancel: function (res) {
                    },
                    fail: function (res) {
                        //alert(JSON.stringify(res));
                    }
                }
                wx.ready(function () {
                    //监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareAppMessage(param);
                    //监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareTimeline(param);
                    //监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareQQ(param);
                    //监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareWeibo(param);
                })
            },
            toShare: function () {
                if (site.isWeiXin()) {
                    this.weixinSdkConfig()
                    this.statuses = true
                } else {
                    this.status = true
                }
            }
        },
        components: {},
        mounted() {
            this.link = this.link ? this.link : window.location.href;
            this.$nextTick(function () {
                if (site.isWeiXin()) {
                    this.getWxToken([
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo'
                    ], this.weixinSdkConfig());
                }
//                if (site.isWeiXin()) {
//                    this.weixinSdkConfig();
//                }
            })
        }
    }
</script>


// WEBPACK FOOTER //
// share.vue?229da18d